<script>
export default {
  name: 'CircleManageModal',
  props: ['type'],
  emits: ['close-drawer'],
  data() {
    return {
      tabIndex: '',
      tabs: {
        '': { name: '基础信息', icon: 'ri-donut-chart-line', disabled: false },
        user: { name: '用户成员', icon: 'ri-group-line', disabled: true },
        post: { name: '帖子管理', icon: 'ri-article-line', disabled: true },
        layout: { name: '布局设置', icon: 'ri-layout-line', disabled: true },
        role: { name: '权限设置', icon: 'ri-shield-user-line', disabled: true },
        privacy: { name: '隐私设置', icon: 'ri-spy-line', disabled: true },
      },
      circle_cats: [],
      data: {
        id: 0,
        name: '',
        desc: '',
        icon: '',
        cover: '',
        slug: '',
        circle_cat: '',
        original_cover: '',
        original_icon: '',
      },
      setting: {
        privacy: {
          type: 'free',
          password: '',
          roles: [],
          pay_group: [{ name: '', price: '', time: '', discount: '' }],
          privacy: 'public',
        },
        role: { join_post: 'global' },
        layout: { info_show: 'global', editor_show: 'global' },
      },
      currentUser: {
        can_create_circle: false,
        is_admin: false,
        is_circle_admin: false,
        is_circle_staff: false,
      },
      privacyTypeOptions: {
        free: '免费',
        money: '付费',
        credit: '积分',
        roles: '专属',
        password: '密码',
      },
      layoutOptions: {
        global: '使用系统设置',
        0: '关闭',
        pc: 'pc端',
        mobile: '移动端',
        all: 'pc端和移动端都显示',
      },
      roleOptions: {
        global: '使用系统设置',
        0: '关闭',
        1: '开启',
      },
      roles: [],
      locked: false,
    };
  },
  computed: {
    isCreate() {
      return this.type === 'create';
    },
    originUrl() {
      return window.location.origin;
    },
    canEditBase() {
      return this.currentUser.is_admin || this.currentUser.is_circle_staff || this.isCreate;
    },
    showSubmit() {
      return (
        this.tabIndex !== 'post'
        && this.tabIndex !== 'user'
        && (this.currentUser.is_admin
          || this.currentUser.is_circle_staff
          || (this.currentUser.can_create_circle && this.isCreate))
      );
    },
  },
  mounted() {
    if (!qktoken && this.isCreate) return this.$createModal('login');

    if (typeof qk_circle !== 'undefined' && !this.isCreate) {
      this.data.id = qk_circle.id;
    }

    this.getUserCircleCapabilities();
  },
  methods: {
    getUserCircleCapabilities() {
      this.$http.post(`${qk_rest_url}getUserCircleCapabilities`, `circle_id=${this.data.id}`).then((res) => {
        delete res.data.editor;
        for (const key in res.data) {
          if (Object.prototype.hasOwnProperty.call(this.currentUser, key)) {
            this.currentUser[key] = res.data[key];
          }
        }

        this.roles = res.data.roles;

        if (!this.isCreate) {
          this.getCircleData();
          if (this.currentUser.is_admin || this.currentUser.is_circle_admin) {
            this.getManageCircle();
          }
        }

        this.getCircleCats();
        this.updateTabs();
      }).catch((err) => {
        this.$message({ message: qkGetApiError(err, '加载圈子权限失败'), type: 'error' });
      });
    },
    getCircleData() {
      this.$http.post(`${qk_rest_url}getCircleData`, `circle_id=${this.data.id}`).then((res) => {
        for (const key in res.data) {
          if (Object.prototype.hasOwnProperty.call(this.data, key)) {
            this.data[key] = res.data[key];
          }
        }
      }).catch((err) => {
        this.$message({ message: qkGetApiError(err, '加载圈子数据失败'), type: 'error' });
      });
    },
    getCircleCats() {
      this.$http.post(`${qk_rest_url}getCircleCats`).then((res) => {
        this.circle_cats = res.data;
      }).catch((err) => {
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
    getManageCircle() {
      this.$http.post(`${qk_rest_url}getManageCircle`, `circle_id=${this.data.id}`).then((res) => {
        this.setting = res.data;
      }).catch((err) => {
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
    createCircle() {
      if (this.locked) return;
      this.locked = true;

      const params = { ...this.data, ...this.setting };
      params.cover = this.data.original_cover ? this.data.original_cover : params.cover;
      params.icon = this.data.original_icon ? this.data.original_icon : params.icon;

      this.$http.post(`${qk_rest_url}createCircle`, params).then(() => {
        this.locked = false;
        this.$message({ message: '成功', type: 'success' });
        this.closeDrawer();
      }).catch((err) => {
        this.locked = false;
        this.$message({ message: qkGetApiError(err, '操作失败'), type: 'error' });
      });
    },
    updateTabs() {
      const isAdminOrCircleStaff = this.currentUser.is_admin || this.currentUser.is_circle_staff;
      const isAdminOrCircleAdmin = this.currentUser.is_admin || this.currentUser.is_circle_admin;

      this.tabs.user.disabled = this.isCreate;
      this.tabs.post.disabled = !isAdminOrCircleStaff || this.isCreate;
      this.tabs.layout.disabled = !isAdminOrCircleAdmin || this.isCreate;
      this.tabs.role.disabled = !isAdminOrCircleAdmin || this.isCreate;
      this.tabs.privacy.disabled = !isAdminOrCircleAdmin || this.isCreate;
    },
    changeTab(index) {
      if (index === this.tabIndex) return;
      this.tabIndex = index;
    },
    imgUploadBox(imgtype) {
      if (!this.currentUser.is_admin && !this.currentUser.is_circle_staff && !(this.currentUser.can_create_circle && this.isCreate)) return;
      this.$createModal('imageUploadBox', {
        size: 400,
        props: {
          data: {
            showTabType: 1,
            maxPicked: 1,
            postType: 'circle',
            callback: (data) => {
              if (imgtype === 'icon') {
                this.data.icon = data[0].url;
                this.data.original_icon = '';
              } else {
                this.data.cover = data[0].url;
                this.data.original_cover = '';
              }
            },
          },
        },
      });
    },
    addPayGroup() {
      this.setting.privacy.pay_group.push({ name: '', price: '', time: '', discount: '' });
    },
    deletePayGroup(index) {
      if (confirm('确定删除吗?')) {
        this.setting.privacy.pay_group.splice(index, 1);
      }
    },
    handleInput(e) {
      e.target.value = e.target.value.trim();
    },
    closeDrawer() {
      this.$emit('close-drawer');
    },
  },
};
</script>

<template>
  <div class="circle-manage-container">
    <div v-if="!isCreate" class="manage-sidebar">
      <div class="circle-image">
        <img v-if="data.icon" :src="data.icon" width="48" height="48" class="w-h" />
      </div>
      <div class="line"></div>
      <div class="circle-sidebar-menu">
        <ul class="menu-list">
          <li
            v-for="(item, index) in tabs"
            v-show="!item.disabled"
            :key="index"
            class="menu-item"
            :class="{ active: tabIndex === index, disabled: item.disabled }"
            @click="changeTab(index)"
          >
            <span class="menu-icon"><i :class="item.icon"></i></span>
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="manage-content">
      <div class="manage-content-head">
        <span class="title">{{ tabs[tabIndex].name }}</span>
      </div>
      <div class="manage-content-wrap">
        <div v-show="tabIndex === ''" class="base-manage">
          <div class="base">
            <div class="circle-cover" @click="imgUploadBox('cover')">
              <div v-colak class="cover-img" style="display: contents">
                <img v-if="data.cover" :src="data.cover" class="w-h" />
                <i v-else class="ri-landscape-fill"></i>
              </div>
            </div>
            <div class="circle-icon" @click="imgUploadBox('icon')">
              <div v-colak class="icon-img" style="display: contents">
                <img v-if="data.icon" :src="data.icon" class="w-h" />
                <i v-else class="ri-camera-fill"></i>
              </div>
            </div>
          </div>
          <div class="form-container">
            <form>
              <label class="form-item">
                <input
                  v-model="data.name"
                  type="text"
                  autocomplete="off"
                  maxlength="100"
                  placeholder="圈子名称"
                  class="input"
                  :disabled="!canEditBase"
                />
                <span class="icon"><i class="ri-file-text-line"></i></span>
              </label>
              <label class="form-item">
                <textarea
                  v-model="data.desc"
                  placeholder="圈子简介"
                  :disabled="!canEditBase"
                ></textarea>
                <span class="icon"><i class="ri-file-text-line"></i></span>
              </label>
              <label class="form-item">
                <input
                  v-model="data.slug"
                  type="text"
                  autocomplete="off"
                  maxlength="100"
                  placeholder="圈子连接"
                  class="input"
                  :disabled="!canEditBase"
                />
                <span class="icon"><i class="ri-link"></i></span>
                <p class="desc">链接：{{ originUrl }}/circle/{{ data.slug }}</p>
              </label>
            </form>
            <div class="circle-cats">
              <div class="section-title">圈子分类</div>
              <ul class="circle-cats-list">
                <li
                  v-for="(item, index) in circle_cats"
                  :key="index"
                  class="list-item"
                  :class="{
                    'bg-text': item.name === data.circle_cat,
                    disabled: !canEditBase,
                  }"
                  @click="data.circle_cat = item.name"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isCreate && !currentUser.can_create_circle" class="nocan-info">
            <div class="text-center">
              <i class="ri-shield-user-fill"></i>
              <p>当前权限不足，无法创建圈子</p>
            </div>
          </div>
        </div>

        <qk-circle-user-manage v-if="tabIndex === 'user'" :current-user="currentUser" />
        <qk-circle-post-manage v-if="tabIndex === 'post'" :current-user="currentUser" />

        <div v-show="tabIndex === 'layout'" class="circle-layout">
          <div class="setting-row">
            <div class="left">顶部信息显示</div>
            <div class="right">
              <div class="select">
                <span>{{ layoutOptions[setting.layout.info_show] }}</span>
                <i class="ri-arrow-right-s-line"></i>
              </div>
              <ul class="select-options">
                <li
                  v-for="(item, index) in layoutOptions"
                  :key="index"
                  class="item"
                  :class="{ active: index === setting.layout.info_show }"
                  @click="setting.layout.info_show = index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div class="setting-row">
            <div class="left">帖子发布框显示</div>
            <div class="right">
              <div class="select">
                <span>{{ layoutOptions[setting.layout.editor_show] }}</span>
                <i class="ri-arrow-right-s-line"></i>
              </div>
              <ul class="select-options">
                <li
                  v-for="(item, index) in layoutOptions"
                  :key="index"
                  class="item"
                  :class="{ active: index === setting.layout.editor_show }"
                  @click="setting.layout.editor_show = index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div v-show="tabIndex === 'role'" class="circle-role">
          <div class="setting-row">
            <div class="left">加入圈子才能发帖</div>
            <div class="right">
              <div class="select">
                <span>{{ roleOptions[setting.role.join_post] }}</span>
                <i class="ri-arrow-right-s-line"></i>
              </div>
              <ul class="select-options">
                <li
                  v-for="(item, index) in roleOptions"
                  :key="index"
                  class="item"
                  :class="{ active: index === setting.role.join_post }"
                  @click="setting.role.join_post = index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div v-show="tabIndex === 'privacy' || (isCreate && tabIndex === '')" class="circle-privacy">
          <div class="setting-row">
            <div class="left">帖子公开显示</div>
            <div class="right">
              <label class="switch">
                <input v-model="setting.privacy.privacy" type="checkbox" />
                <span class="slider-dot"></span>
              </label>
            </div>
          </div>
          <div class="setting-row">
            <div class="left">圈子类型</div>
            <div class="right">
              <div class="select">
                <span>{{ privacyTypeOptions[setting.privacy.type] }}</span>
                <i class="ri-arrow-right-s-line"></i>
              </div>
              <ul class="select-options">
                <li
                  v-for="(item, index) in privacyTypeOptions"
                  :key="index"
                  class="item"
                  :class="{ active: index === setting.privacy.type }"
                  @click="setting.privacy.type = index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="setting.privacy.type === 'password'" class="setting-row">
            <div class="left">圈子密码</div>
            <div class="right">
              <input
                v-model="setting.privacy.password"
                type="text"
                autocomplete="off"
                maxlength="4"
                placeholder="圈子密码（纯数字）"
                class="input"
                style="background: var(--bg-muted-color); border-radius: var(--radius); max-width: 100px; padding: 5px 10px"
              />
            </div>
          </div>
          <div v-if="setting.privacy.type === 'roles'" class="setting-roles">
            <div class="title">请选择专属等级</div>
            <ul>
              <li v-for="(lv, key) in roles" :key="key">
                <label>
                  <input v-model="setting.privacy.roles" type="checkbox" :value="key" />
                  <span>{{ lv }}</span>
                </label>
              </li>
            </ul>
          </div>
          <div
            v-if="setting.privacy.type === 'money' || setting.privacy.type === 'credit'"
            class="setting-pay-group"
          >
            <div class="title">设置付费组</div>
            <div class="pay-group-header">
              <div class="name">名称<b class="red">*</b></div>
              <div class="price">入圈价格(元/积分)<b class="red">*</b></div>
              <div class="time">有效期(天)<b class="red">*</b></div>
              <div class="discount">会员折扣(%)<b class="red">*</b></div>
            </div>
            <div
              v-for="(item, index) in setting.privacy.pay_group"
              :key="index"
              class="pay-group-body"
            >
              <div class="name">
                <input v-model="item.name" type="text" placeholder="例：一个月" @input="handleInput" />
              </div>
              <div class="price">
                <input v-model="item.price" type="number" step="1" maxlength="4" placeholder="例：20" @input="handleInput" />
              </div>
              <div class="time">
                <input v-model="item.time" type="number" step="1" maxlength="4" placeholder="例：30" @input="handleInput" />
              </div>
              <div class="discount">
                <input v-model="item.discount" type="number" step="1" maxlength="4" placeholder="例：97" @input="handleInput" />
                <button v-if="setting.privacy.pay_group.length > 1" @click="deletePayGroup(index)">删除</button>
              </div>
            </div>
            <div class="add-pay-group"><button @click="addPayGroup">添加</button></div>
            <div class="pay-group-matter">
              <ol>
                <li>名称：入圈支付时显示，比如 月付、季付、年付、永久有效 等等</li>
                <li>价格：入圈支付的金额或积分</li>
                <li>有效期：用户入圈有效天数，如果填写0则永久有效</li>
                <li>会员折扣：如果用户是会员使用折扣价</li>
              </ol>
            </div>
          </div>
        </div>

        <div v-if="showSubmit" class="submit-button">
          <button class="publish" @click="createCircle">{{ isCreate ? '创建' : '保存' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
